import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
const ApiClient = {
  listMtObjects: async () => {
    const api = new ApiService(`${BASE_URL}/mt_objects`, { "Content-Type": "application/json" }, "GET");
    try {
      const res = await api.makeCall();
      const objects = res?.response || res?.data || res || [];
      return objects.map((o) => ({ label: o.label || o.name, value: o.name, raw: o }));
    } catch (e) {
      console.error(e);
      return [];
    }
  },

  listMtFields: async (objectName) => {
    const api = new ApiService(
      `${BASE_URL}/mt_fields/object/${objectName}`,
      { "Content-Type": "application/json" },
      "GET"
    );

    try {
      const res = await api.makeCall();
      const data = res?.response || res?.data || res || [];

      return data.map((f) => ({
        label: f.label || f.field_label || f.api_label || f.name,
        name: f.name || f.api_name || f.field_name,
        type: f.type || f.data_type || (f.dataType && String(f.dataType)),
        raw: f,
      }));
    } catch (e) {
      console.error(e);
      return [];
    }
  },

  runPipeline: async (objectName, pipeline) => {
    const api = new ApiService(`${BASE_URL}/pipeline/run`, { "Content-Type": "application/json" }, "POST", JSON.stringify({ object: objectName, pipeline }));
    try { return await api.makeCall(); } 
    catch (e) { console.error(e); return { error: true, message: e.message }; }
  },

  createPipeline: async (payload) => {
    const api = new ApiService(`${BASE_URL}/pipeline`, { "Content-Type": "application/json" }, "POST", JSON.stringify(payload));
    try { return await api.makeCall(); } 
    catch (e) { console.error(e); return { errors: [e.message] }; }
  },

  getPipelineById: async (id) => {
    const api = new ApiService(
      `${BASE_URL}/pipeline/${id}`,
      { "Content-Type": "application/json" },
      "GET"
    );

    try {
      return await api.makeCall();
    } catch (e) {
      console.error(e);
      return null;
    }
  },

  updatePipeline: async (id, payload) => {
    const api = new ApiService(
      `${BASE_URL}/pipeline/${id}`,
      { "Content-Type": "application/json" },
      "PUT",
      JSON.stringify(payload)
    );

    try {
      return await api.makeCall();
    } catch (e) {
      console.error(e);
      return { errors: [e.message] };
    }
  }

};

export default ApiClient;
